import { fetchDivisionFixtures } from "./insightsData";
import { predictionsBefore } from "./predictions";

const canPredict = (g) => !!g.fixture && g.score !== "FF" && !g.fixture.is_forfeit;

/**
 * Adds `predicted` ("2–1") and `odds` ({ home, draw, away }) to games from the
 * Insights model as it stood before that matchday: played games and the next
 * matchday's upcoming ones. Games keep their shape when a prediction isn't available.
 */
export async function withPredictedScores(games) {
  const groups = new Map();
  for (const g of games) {
    const f = g.fixture;
    if (!canPredict(g) || !f.season || !f.city || !f.division) continue;
    const key = `${f.season}|${f.city}|${f.division}`;
    if (!groups.has(key)) groups.set(key, { season: f.season, city: f.city, division: f.division, ids: [] });
    groups.get(key).ids.push(f.id);
  }
  if (!groups.size) return games;
  const predicted = {};
  await Promise.all(
    [...groups.values()].map(async ({ ids, ...league }) => {
      Object.assign(predicted, predictionsBefore(await fetchDivisionFixtures(league), ids));
    })
  );
  return games.map((g) => {
    const p = canPredict(g) ? predicted[g.fixture.id] : null;
    if (!p) return g;
    const [h, a] = p.likelyScore;
    return { ...g, predicted: `${h}–${a}`, odds: { home: p.home, draw: p.draw, away: p.away } };
  });
}
